import store from 'Store';

function requestConfirmPrivacy(to, from, next) {
  let { redirect, from: fromQuery } = to.query;
  // if there is no redirect in url and it's not a auth pages (sing-in or sign-up)
  if (!redirect && !to.name.startsWith('sign')) {
    redirect = to.path + to.hash;
  } // Set redirect to current page
  if (!fromQuery && !to.name.startsWith('sign')) {
    fromQuery = to.path;
  } // Set redirect to current page
  next({
    name: 'sign-up-social',
    query: { ...to.query, from: fromQuery, redirect },
  });
}

export async function resolveConfirmPrivacy(to, from, next) {
  if (
    store.getters['login/isLoggedIn']
    // excluded page
    && !['sign-up-social', 'terms', 'privacy'].includes(to.name)
  ) {
    const profileData = await store.getters['profile/profileDataPromise'];
    if (profileData && !profileData.confirm_privacy && !store.getters['profile/isPrivacyConfirmed']) {
      requestConfirmPrivacy(to, from, next);
      return Promise.reject(new Error('Confirm Privacy Required'));
    }
  }
  return Promise.resolve();
}
